export default "__VITE_ASSET__DUfMBZ3Y__"